import React from 'react';
import { storage } from 'utils/usePersistState';
import { usePartner } from '../hooks/usePartner';

function Logout() {
  const [partner] = usePartner();
  React.useEffect(() => {
    storage.remove('user-session');
    window.location.href = `/?partner_id=${partner.id}`;
  }, [partner]);
  return <div className="text-center text-gray-500">Please wait...</div>;
}

Logout.propTypes = {};

export default Logout;
